import { Typography } from '@app/components';
import { clsxm } from '@app/styles/clsxm';

// admin-emailbeheer blok B. Card shadow/radius match admin-email-mockup_3.html's .card rule.
export const EmailCard: React.FC<{
  title?: string;
  subtitle?: React.ReactNode;
  headerRight?: React.ReactNode;
  className?: string;
  children: React.ReactNode;
}> = ({ title, subtitle, headerRight, className, children }) => (
  <div className={clsxm('rounded-md bg-white p-5 shadow-card', className)}>
    {(title || headerRight) && (
      <div className="mb-3 flex items-start justify-between gap-4">
        <div>
          {title && (
            <Typography variant="s" className="font-bold text-gray-800">
              {title}
            </Typography>
          )}
          {subtitle && (
            <Typography variant="xxs" className="mt-0.5 text-gray-400">
              {subtitle}
            </Typography>
          )}
        </div>
        {headerRight}
      </div>
    )}
    {children}
  </div>
);
